import { Text } from "preact-i18n";
import { useEffect } from "preact/hooks";
import classNames from "classnames";
import { PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON_CLICK, EMIT_LOAD_PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON } from "../../helpers/event-definitions";

import "../../style/InvoiceAlreadyPaidSection.css";

const InvoiceAlreadyPaidSection = ({
  transactionId,
  isDesktopOrLaptop,
  amount,
  surchargeAmount,
  businessName,
  isPDFExperimentOn,
  c2Analytics,
}) => {
  const endingPagePaidInvoiceClassNames = classNames({
    "ending-page-mobile-paid-invoice": !isDesktopOrLaptop,
    "ending-page-section-paid-invoice": true,
  });

  const baseUrl = window.location.origin;

  const queryParams = new URLSearchParams({
    orderId: payLink?.invoice?.orderId || '',
  })

  const downloadPDFLink = `${baseUrl}/pdf?${queryParams.toString()}`;

  const handlePDFDownloadClick = () => {
    if (c2Analytics?.trackCustomEvent) {
      c2Analytics.trackCustomEvent(PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON_CLICK);
    }
  };

  // track custom event on first load
  useEffect(() => {
    if (c2Analytics?.trackCustomEvent && isPDFExperimentOn) {
      c2Analytics.trackCustomEvent(EMIT_LOAD_PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON);
    }
  }, []);

  return (
    <div className={endingPagePaidInvoiceClassNames}>
      <div className="ok-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="none">
          <path
            fill="#000"
            fill-rule="evenodd"
            d="M33.258 16.448a.75.75 0 0 1 .044 1.06l-11.98 13.038a1.75 1.75 0 0 1-2.628-.057l-5.268-6.256a.75.75 0 0 1 1.148-.966l5.268 6.256a.25.25 0 0 0 .375.008l11.98-13.038a.75.75 0 0 1 1.06-.045Z"
            clip-rule="evenodd"
          />
          <path
            fill="#111"
            fill-rule="evenodd"
            d="M23 1.75C11.264 1.75 1.75 11.264 1.75 23S11.264 44.25 23 44.25 44.25 34.736 44.25 23 34.736 1.75 23 1.75ZM.25 23C.25 10.435 10.435.25 23 .25S45.75 10.435 45.75 23 35.565 45.75 23 45.75.25 35.565.25 23Z"
            clip-rule="evenodd"
          />
        </svg>

        {isPDFExperimentOn ? (
          <a className="invoice-download" href={downloadPDFLink} target="_blank" rel="noopener noreferrer" onClick={handlePDFDownloadClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
            <Text id="INVOICE">Invoice</Text>
          </a>
        ) : null}
      </div>
      <div className="ending-page-paid-invoice-details-section">
        <div className="ending-page-paid-invoice-description">
          <Text id="ENDING_PAGE_PAID_INVOICE_DESCRIPTION" fields={{ amount, businessName }}>
            You paid {amount} to {businessName}
          </Text>
        </div>
        {surchargeAmount ? (
          <div className="ending-page-paid-invoice-surcharge">
            <Text id="ENDING_PAGE_PAID_INVOICE_SURCHARGE" fields={{ surchargeAmount }}>
              {surchargeAmount} surcharge included.
            </Text>
          </div>
        ) : null}
        <div className="ending-page-paid-invoice-transaction-id">
          <Text id="ENDING_PAGE_PAID_INVOICE_TRANSACTION_ID" fields={{ transactionId }}>
            Transaction ID {transactionId}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default InvoiceAlreadyPaidSection;
